// Node.js polyfills for browser compatibility
// Required by @solana/web3.js and Web3Auth packages
import { Buffer } from 'buffer';
// @ts-expect-error - process/browser has no types; shimmed for browser compat
import process from 'process/browser';

// Make Buffer available globally
window.Buffer = Buffer;
globalThis.Buffer = Buffer;

// Make process available globally
window.process = process;
globalThis.process = process;
